import { combineReducers } from "redux";
import * as actionTypes from "../actions/types";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const apiMode =
  window.location.origin === "http://localhost:3000" ? "test" : "prod";

const initialState = {
  platform: "",
  googlePlatform: "",
  hash: "",
  campaignId: "",
  campaignName: "",
  campaignText:
    "I just bought an amazing new outfit for work from the summer collection! Sign up through my referral link to receive a $50 credit.",
  mode: "Ready Made Post",
  wp: false,
  multirow: false,
  landingData: null,
  fetchingLanding: false,
  readyMadeData: null,
  fetchingReadyMade: false,
  fetchingURL: false,
  urlData: null,
  error: null,
  apiMode: apiMode,
  activeCategory: "",
  posts: [],
  filteredPosts: [],
  categories: [],
  categoryID: null,
  filteredCategory: "",
  vParam: null,
  urlParam: null,
  whitelabel: {},
  customText: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PLATFORM:
      return {
        ...state,
        platform: action.payload,
      };
    case actionTypes.UPDATE_GOOGLE_PLATFORM:
      return {
        ...state,
        googlePlatform: action.payload,
      };
    case actionTypes.UPDATE_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case actionTypes.SET_CATEGORY:
      return {
        ...state,
        activeCategory: action.payload,
      };
    case actionTypes.SET_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };
    case actionTypes.SET_CATEGORYID:
      return {
        ...state,
        categoryID: action.payload,
      };
    case actionTypes.SET_WEBSITE_EMBEDDING:
      return {
        ...state,
        wp: action.payload,
      };
    case actionTypes.SET_MULTIROW:
      return {
        ...state,
        multirow: action.payload,
      };
    case actionTypes.LANDING_START:
      return {
        ...state,
        fetchingLanding: true,
      };
    case actionTypes.LANDING_SUCCESS:
      const landingWhitelabel = action.payload.whitelabel
        ? action.payload.whitelabel
        : {};

      if (landingWhitelabel.buttonCornerRadius) {
        if (landingWhitelabel.buttonCornerRadius === true) {
          landingWhitelabel.buttonCornerRadius = "1px";
        } else {
          landingWhitelabel.buttonCornerRadius = `${landingWhitelabel.buttonCornerRadius.toString()}px`;
        }
      } else if (landingWhitelabel.buttonCornerRadius === false) {
        landingWhitelabel.buttonCornerRadius = "0px";
      }

      return {
        ...state,
        fetchingLanding: false,
        landingData: action.payload,
        whitelabel: landingWhitelabel,
      };
    case actionTypes.LANDING_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.READY_MADE_START:
      return {
        ...state,
        fetchingReadyMade: true,
      };
    case actionTypes.READY_MADE_SUCCESS:
      const whitelabel = action.payload.whitelabel
        ? action.payload.whitelabel
        : {};

      if (whitelabel.cardCornerRadius) {
        if (whitelabel.cardCornerRadius === true) {
          whitelabel.cardCornerRadius = "1px";
        } else {
          whitelabel.cardCornerRadius = `${whitelabel.cardCornerRadius.toString()}px`;
        }
      } else if (whitelabel.cardCornerRadius === false) {
        whitelabel.cardCornerRadius = "0px";
      }

      if (whitelabel.pictureFooterCornerRadius) {
        if (whitelabel.pictureFooterCornerRadius === true) {
          whitelabel.pictureFooterCornerRadius = "1px";
        } else {
          whitelabel.pictureFooterCornerRadius = `${whitelabel.pictureFooterCornerRadius.toString()}px`;
        }
      } else if (whitelabel.pictureFooterCornerRadius === false) {
        whitelabel.pictureFooterCornerRadius = "0px";
      }

      if (whitelabel.buttonCornerRadius) {
        if (whitelabel.buttonCornerRadius === true) {
          whitelabel.buttonCornerRadius = "1px";
        } else {
          whitelabel.buttonCornerRadius = `${whitelabel.buttonCornerRadius.toString()}px`;
        }
      } else if (whitelabel.buttonCornerRadius === false) {
        whitelabel.buttonCornerRadius = "0px";
      }

      if (whitelabel.socialPlatformButtonsCornerRadius) {
        if (whitelabel.socialPlatformButtonsCornerRadius === true) {
          whitelabel.socialPlatformButtonsCornerRadius = "1px";
        } else {
          whitelabel.socialPlatformButtonsCornerRadius = `${whitelabel.socialPlatformButtonsCornerRadius.toString()}px`;
        }
      } else if (whitelabel.socialPlatformButtonsCornerRadius === false) {
        whitelabel.socialPlatformButtonsCornerRadius = "0px";
      }

      if (
        !whitelabel.socialPlatformButtonsCornerRadius ||
        whitelabel.socialPlatformButtonsCornerRadius === null
      ) {
        whitelabel.socialPlatformButtonsCornerRadius = "4px";
      }

      if (
        whitelabel.dropShadow === undefined ||
        whitelabel.dropShadow === null
      ) {
        whitelabel.dropShadow = true;
      }

      if (
        !whitelabel.pictureFooterBorderColor ||
        whitelabel.pictureFooterBorderColor === null
      ) {
        whitelabel.pictureFooterBorderColor = "#dadadb";
      }

      if (
        !whitelabel.pictureFooterCornerRadius ||
        whitelabel.pictureFooterCornerRadius === null
      ) {
        whitelabel.pictureFooterCornerRadius = "4.571px";
      }

      if (
        !whitelabel.cardCornerRadius ||
        whitelabel.cardCornerRadius === null
      ) {
        whitelabel.cardCornerRadius = "8px";
      }

      const posts =  action.payload.readyMadePosts.map((p) => {
        p.readyMadePost.text = p.readyMadePost.text.toString();
        p.readyMadePost.linkCaption = p.readyMadePost.linkCaption.toString();
        return p;
      });

      const postsToShow = state.categoryID ? posts.filter(
        (post) => post.readyMadePost.categoryID === state.categoryID
      ) : posts;

      return {
        ...state,
        fetchingReadyMade: false,
        readyMadeData: action.payload,
        posts: postsToShow,
        filteredPosts: postsToShow,
        whitelabel: whitelabel,
      };
    case actionTypes.READY_MADE_FAILURE:
      return {
        ...state,
        error: { message: action.payload },
      };
    case actionTypes.URL_SHORTEN_START:
      return {
        ...state,
        fetchingURL: true,
      };
    case actionTypes.URL_SHORTEN_SUCCESS:
      return {
        ...state,
        fetchingURL: false,
        urlData: `https://app.speechifai.tech/s/${action.payload}`,
      };
    case actionTypes.URL_SHORTEN_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.FILTER_POSTS:
      const goodPosts = state.posts.filter(
        (post) => post.readyMadePost.categoryID === action.payload
      );
      return {
        ...state,
        filteredPosts: goodPosts,
      };
    case actionTypes.RETURN_POSTS:
      return {
        ...state,
        filteredPosts: state.posts,
      };
    case actionTypes.FILTER_CATEGORY:
      return {
        ...state,
        filteredCategory: state.categories.filter(
          (cat) => cat.id === action.payload
        )[0],
      };
    case actionTypes.SET_DEFAULT_CATEGORY:
      return {
        ...state,
        categories: action.payload,
        activeCategory: action.payload[0].name,
      };
    case actionTypes.SET_URL_PARAMS:
      return {
        ...state,
        urlParam: action.payload,
      };
    case actionTypes.SET_EDITING:
      return {
        ...state,
        editing: action.payload.editState,
        filteredPosts: state.filteredPosts.map((post) =>
          post.readyMadePost.id === action.payload.id
            ? { ...post, editing: action.payload.editState }
            : post
        ),
      };

    case actionTypes.EDIT_POST_TEXT: {
      const { id, text } = action.payload;
      const cleanedText = text.replace(/<\/?(span|i|br|div)[^>]*>/g, "");
      const oldPosts = state.filteredPosts;

      const newPosts = oldPosts.map((post) => {
        if (post.readyMadePost.id === id) {
          return {
            ...post,
            readyMadePost: { ...post.readyMadePost, text: cleanedText },
            editing: false,
          };
        } else {
          return post;
        }
      });

      return {
        ...state,
        filteredPosts: newPosts,
      };
    }
    case actionTypes.SET_CUSTOM_TEXT:
      return {
        ...state,
        customText: action.payload,
      };

    default:
      return state;
  }
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const rootReducer = combineReducers({
  sharer: reducer,
});

export default persistReducer(persistConfig, rootReducer);
